import { AdminType, APIGet, APIUrl, APIPost } from "api/protocols";
import { CancelToken } from "axios";
import { ICustomer } from "redux/reducers/models/customer";
import { IBooking } from "redux/reducers/models/teetime";

export interface IGetBookingDeposit {
  id?: number;
  offset?: number;
  limit?: number;
  customer?: boolean;
  booking?: boolean;
  refunds?: boolean;
  customer_id?: number;
  /**Only return deposits where amount_remaining > 0 */
  remaining_only?: boolean;
  search?: string;
  filters?: Array<{label: string; value: any}>;
}

export interface IBookingDeposit {
  id: number;
  facility_id: number;
  client_id: number;
  amount: number;
  amount_remaining: number;
  currency: string;
  payment_option_id: number;
  payment_method: string;
  payment_type: string;
  payment_last_4: number;
  payment_intent_id: string;
  charge_id: string;
  kind: string;
  parent_id: number;
  source: string;
  processing_type: string;
  card_reader_id: number;
  gateway: string;
  error_code: string;
  processed_at: string;
  processed_at_local: string;
  created_at: string;
  updated_at: string;
  refunded?: boolean;
  partially_refunded?: boolean;
  refund_transaction?: {
    amount: number | string;
  };
  customer?: ICustomer;
  booking?: IBooking;
  status?: string;
}

export async function GetBookingDeposit(params: IGetBookingDeposit, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet<Array<IBookingDeposit>>(APIUrl(AdminType.FacilityAdmin, "/deposit"), params, useGlobalLoader, cancelToken);
}

export async function PostBookingDepositRefund(params: { deposit_id: number | string, amount: number }, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/deposit/refund"), params, useGlobalLoader);
}

export async function GetBookingDepositReceipt(params: { deposit_id: number | string }, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/deposit/receipt"), params, useGlobalLoader);
}
